import { useState } from "react";
import { useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import { GlobalConstants } from "../../constants/GlobalConstants";
import BCModal from "../../ui/BCModal";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";

const MainTable = () => {
  const [isCheckNetSuiteDataOpen, setIsCheckNetSuiteDataOpen] = useState(false);
  const [checkedLoanTransactionId, setCheckedLoanTransactionId] = useState("");

  const handleClickCheckNetSuiteData = async({
    firstCheckedRow: { id },
  }: {
    firstCheckedRow: { id: string };
  }) => {
    setIsCheckNetSuiteDataOpen(true);
    setCheckedLoanTransactionId(id);
  };

  return <>
    {checkedLoanTransactionId && <BCModal
      isModalOpen={isCheckNetSuiteDataOpen}
      size="large"
      closeIcon
      onClose={() => setIsCheckNetSuiteDataOpen(false)}
      content={<>
        <LmsTable
          apiSuffix={`accounting/${checkedLoanTransactionId}/loan-payment/net-suite-data`}
          actionButtons={[{ action: "close", handleClick: () => setIsCheckNetSuiteDataOpen(false) }]}
          rowBackgroundColorConditionFunc={(row) => row.voided === "Yes" }
          rowBackgroundColor="pink"
        />
      </>}
    />}
    <LmsTable
      actionButtons={[
        "edit", 
        "export",
        {
          text: "Void", 
          action: GlobalConstants.TableDefaultActions.SUBMIT_SELECTED,
          submitSuffix: "loans/void-payment",
          isDisabled: (checkedItems) => checkedItems?.length < 1,
          method: "PUT",
          refreshDataOnSuccess: true,
          confirmationMessage: "Are you sure you want to Void the selected record(s)?"
        },
        { 
          text: "Check NetSuite Data", 
          isDisabled: (checkedItems) => checkedItems?.length !== 1,
          handleClick: handleClickCheckNetSuiteData 
        }
      ]}
      apiSuffix="accounting/loan-payments"
      rowBackgroundColorConditionFunc={(row) => row.isActive === false} 
      rowBackgroundColor="pink"
    />
  </>;
};

const loanPaymentsFormFields = (myForm: BCFormController) => {
  myForm.addCenteredGroup([myForm.getDropdownField("Bank Organization", "orgs/list-bank-orgs", { name: "bankOrganizationId", disabled: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Loan", "loans/list-borrower-loans", { name:"loanId", required: true, disabled: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Transaction Category", "loans/list-transaction-category", { name: "transactionCategoryId", required: true, disabled: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Transaction Type", "loans/list-transaction-type", { name: "transactionTypeId", required: true, disabled: true })]);
  myForm.addCenteredGroup([myForm.getInputField("Transaction Amount", { fieldType: "dollar", required: true, disabled: true })]);
  myForm.addCenteredGroup([
    myForm.getCalendarField("Transaction Due Date", { name: "transactionDueDate", required: true, disabled: true }),
    myForm.getCalendarField("Transaction Effective Date", { required: true, disabled: true }),
  ]);

  myForm.addCenteredGroup([myForm.getCheckboxField("Voided", { name: "voided", inline: true, isDisabledOnFunc: ({ inputs }) => !inputs.isActive })]);
  myForm.addCenteredGroup([myForm.getTextareaField("Description", { name: "description" })]);
  return myForm;
};

export const EditLoanPaymentsForm = ({ id, handleClose }: { id: string; handleClose? }) => {
  const [{ data = {}, error }] = useFetchData(`loans/loan-payment/${id}`);
  const [{ data: loanData = {} }] = useFetchData(`loandetails/history/payment-transactions/${id}`);
  const initialValues = {
    ...data,
    voided: loanData[0]?.voided,
  };
  
  const myForm = new BCFormController(initialValues, { submitSuffix: "loans/update-loan-payment", submitMethod: "PUT", blankWidth: 4 });
  loanPaymentsFormFields(myForm);
  const formActions = ["save", "save-close", "close"];
  return (<>
    <LmsFormGenerator
      myForm={myForm}
      error={error}
      actions={formActions}
      submitConfirmationMessage={({ inputs }) => inputs.voided && inputs.isActive ? "Are you sure you want to void this payment?" : ""}
      handleClose={handleClose}
    />
    <LmsTable
      title="Loan Transaction"
      actionButtons={["export"]}
      apiSuffix={`loans/loan-payment-transactions/${id}`}
      skipClick
    />
  </>);
};

const LmsAccountingLoanPayments = ({ params = {}, history }) => {
  const { isMainPage, isEdit, isActionAllowed, id } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <>
      {isMainPage && <MainTable />}
      {isEdit && <EditLoanPaymentsForm id={id} />}
    </>
  );
};

export default LmsAccountingLoanPayments;